import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spin from 'antd/lib/spin';

import { selectIsInProgress } from '../../spinner/ducks';
import {
  fetchAccountMessagesActions,
  createAccountMessageActions,
  selectMessages,
  selectMessagesFilter,
  setAccountMessagesFilterAction,
} from '../ducks';
import {
  fetchQuestionsActions,
  selectQuestions,
  selectQuestionFilter,
  setQuestionsFilterAction
} from '../../help-management/ducks'
import { apiCallIds as questionApiCallIds } from '../../help-management/api'
import { apiCallIds as accountApiCallIds } from '../api';
import { AccountMessages } from '../components';
import { t } from '../../../app/i18n';

const mapStateToProps = state => ({
  messages: selectMessages(state),
  messagesFilter: selectMessagesFilter(state),
  questions: selectQuestions(state),
  // questionFilter: selectQuestionFilter(state),
  isLoading: selectIsInProgress(state, accountApiCallIds.FETCH_ACCOUNT_MESSAGES),
  isLoadingQ: selectIsInProgress(state, questionApiCallIds.FETCH_QUESTIONS)
});

const mapDispatchToProps = {
  fetchAccountMessages: fetchAccountMessagesActions.request,
  addAccountMessage: createAccountMessageActions.request,
  fetchQuestions: fetchQuestionsActions.request,
  setMessagesFilter: setAccountMessagesFilterAction,
}


class AccountMessageContainer extends Component {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    messages: PropTypes.array.isRequired,
    questions: PropTypes.array.isRequired,
    messagesFilter: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fetchAccountMessages: PropTypes.func.isRequired,
    fetchQuestions: PropTypes.func.isRequired,
    addAccountMessage: PropTypes.func.isRequired,
    setMessagesFilter: PropTypes.func.isRequired,
  };

  

  componentDidMount() {
    const { fetchAccountMessages, accountId, messagesFilter, fetchQuestions } = this.props;
    fetchAccountMessages({
      accountId,
      options: {
        internal: messagesFilter.includes('internal'),
        external: messagesFilter.includes('external'),
      }
    });
    const defaultQFilter = {
      search: '',
      accountId: accountId,
    }
    fetchQuestions(defaultQFilter)
  }

  onSave = message => {
    const { accountId, addAccountMessage, messagesFilter } = this.props;
    addAccountMessage({
      accountId,
      message,
      messagesFilter,
    });
  };

  onFilterChange = checkedValues => {
    const { setMessagesFilter, accountId } = this.props;
    setMessagesFilter({
      accountId,
      options: {
        internal: checkedValues.includes('internal'),
        external: checkedValues.includes('external'),
      },
      newFilter: checkedValues,
    });
  };

  render() {
    const {
      messages,
      messagesFilter,
      isLoading,
      questions,
      isLoadingQ
    } = this.props;

    return (
      <Spin spinning={isLoading}>
        <AccountMessages
          onSave={this.onSave}
          messages={messages}
          messagesFilter={messagesFilter}
          questions={questions}
          isLoadingQ={isLoadingQ}
          isLoading={isLoading}
          onFilterChange={this.onFilterChange}
        />
      </Spin>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountMessageContainer);



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountMessageContainer.js